import { DEFAULT_GAME_ID, LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const getAllCurrencyService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-all-currency', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}
export const getGameSettingService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-game-settings', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

export const getGameDetailsService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-game-settings', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}

export const verifyRoundHashService = (data) => {
  let endPoint = ''
  let payLoadData = {}
  if (data.gameId === DEFAULT_GAME_ID.CRASH ||
    data.gameId === DEFAULT_GAME_ID.CHOPPER_CRASH ||
    data.gameId === DEFAULT_GAME_ID.SOCCER_CRASH ||
    data.gameId === DEFAULT_GAME_ID.MULTI_CRASH) {
    endPoint = 'fast-games/crash-game/check-provable-fair'
    payLoadData = {
      roundHash: data.hashCode,
      currencyCode: data.currencyCode
    }
  }
  return axiosInstanceService(METHOD_TYPES.post, endPoint, payLoadData, {
    server: microServices.SERVICE_URL_1
  })
}
